module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAA8UlEQVQokX3STS4EYRAG4Kd7/MUVnGHOgYQwU2QyIYQ4FSsRIfQXJiLYuIKlnXP4zVj4OiamR62fVL2pqqKqqie8oB8R7yZUiWd0cZFSmvkP7uASa0iTcBkRn+jjHCu4TinNNnUUEV/YximWM54bgyN4FydYynh+DI7gPRxjEYMaF8PhcCx4SqnEEfbxiNVGmHGBQxzgrmxUv7HqVRVTE7q1cs4tPKA7BjM68bPbe3Qi4rVsQKcZ3WI9Il7rHDWaxhl6uEE3It5GA8v3PcMmBtj4+0mtdrs94+fOXVyh1/RuZUYdVJNQDRfy2H5EfDQh+AZak1t3y9gM2gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/jxwx/arr_05.png
// module id = CeRm
// module chunks = 1